import { Button } from 'antd'
import styled, { css } from 'styled-components'

export const formValidationStyles = css`
  input[aria-invalid='true'] {
    border: 2px solid red;
  }

  div[aria-invalid='true'] {
    border: 2px solid red;
  }

  div.rs-picker-date:has(input[aria-invalid='true']) {
    border: 2px solid red;
  }

  span[role='alert'] {
    color: red;
  }
`

export const StyledFormSubmitButton = styled(Button)`
  width: 100%;
  margin: 15px 0 5px 0;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.background2} !important;
  }
`

export const StyledFormInput = styled.input`
  color: ${({ theme }) => theme.forecast.text1} !important;
  background-color: ${({ theme }) => theme.forecast.background1} !important;
  border-color: ${({ theme }) => theme.forecast.border2} !important;

  &::placeholder {
    color: ${({ theme }) => theme.forecast.textDisabled} !important;
  }
`
